import { Tenant } from '../models/tenant';

// URL segura pra recarregar após troca de empresa. Dentro de um registro (/produtos/editar/38268,
// /pedidos/57...) o reload na mesma URL quebra: o id pertence à empresa anterior e a tela cai em
// "registro não encontrado". Regra: mais de um segmento → volta pra raiz do módulo (a listagem);
// um segmento (listagem/home) → mantém a URL, filtros de query inclusos.
export function safeUrlAfterCompanySwitch(pathname: string, search: string): string {
  const segments = pathname.split('/').filter(Boolean);
  return segments.length > 1 ? `/${segments[0]}` : `${pathname}${search}`;
}

// Troca a empresa ativa e recarrega em `url` (o reload reconecta o feed e limpa estado da empresa
// anterior). Sinaliza o splash de troca (renderizado pelo index.html já no reload, cobrindo o
// bootstrap — sem tela branca). Usada pelo seletor e pelo alerta de integração de outra filial.
export function switchCompanyAndGo(
  stateService: { setTenant(tenant: Tenant): void },
  target: Tenant,
  url: string,
  go: (url: string) => void = (u) => window.location.assign(u),
): void {
  stateService.setTenant(target);
  sessionStorage.setItem('mc_switch', JSON.stringify({
    name: target.fantasyName || target.name,
    group: target.groupDisplayName || target.companyGroupName || '',
    avatarUrl: target.avatarUrl || '',
    // Cor e logo do grupo de DESTINO: o splash do index.html lê antes do Angular subir.
    color: target.brandColor || '',
    logoUrl: target.logoWideUrl || '',
  }));
  go(url);
}
